<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">干货分享 | 《人机共生——大模型时代的AI十大趋势报告》</div>
      <div class="news-date">2023年7月7日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <p>
          7月7日，世界人工智能大会期间，《人机共生——大模型时代的AI十大趋势报告》发布。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news38.jpeg"/>
          </div>
        </div>
        <p>报告由腾讯研究院、同济大学、腾讯云共同编制发布，基于科技行业的发展情况，以及产学研三方在AI领域的研究，从技术、应用、社会等角度，提出大模型时代的关键趋势观察。</p>
        <div class="news-content-mark">
          <div>一图了解《人机共生——大模型时代的AI十大趋势观察》↓</div>
        </div>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/report/news38/news38_1.png"/>
            <img class="news-image" src="../img/detail/report/news38/news38_2.jpeg"/>
            <img class="news-image" src="../img/detail/report/news38/news38_3.jpeg"/>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News33',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    font-size: 0;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .highlight {
    color: #0052FF;
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News38.vue